export default __webpack_public_path__ + "static/media/post-suvinil5.b5c6d3e5.png";